var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevronRight20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.64 3.81a.75.75 0 0 1 1.06 0l5.66 5.66a.75.75 0 0 1 0 1.06L8.7 16.19a.75.75 0 1 1-1.06-1.06L12.77 10 7.64 4.87a.75.75 0 0 1 0-1.06Z",
  fill: "#8B97A7"
})));
export default SvgIcChevronRight20X20;